import { seatingGuestOperationsRoutes } from '@/app/modules/seating/guestOperations/seating-guest-operations.routes';
import { redirectIfUnauthorized } from '@/app/shared/utils/router-guards/auth';

const BASE_PATH = '/seating';

const SeatingRoutes = [
    ...seatingGuestOperationsRoutes,
    {
        name: 'SeatingEditor',
        path: `${BASE_PATH}/editor/:venueId/:seatPlanId`,
        component: () => import('@/app/modules/seating/Editor/Editor.vue'),
        props: true,
        // TODO: change redirection after permissions will be known
        beforeEnter: redirectIfUnauthorized((permissions) => permissions.seating.seatEditor),
    },
    {
        name: 'SeatingFacilitiesList',
        path: `${BASE_PATH}/facilities`,
        component: () => import('@/app/modules/seating/FacilitiesList/FacilitiesList.vue'),
        props: true,
        beforeEnter: redirectIfUnauthorized((permissions) => permissions.seating.seatEditor),
    },
];

export default SeatingRoutes;
